module.exports = __webpack_public_path__ + "static/media/card-blog17.dd6f858a.jpg";